import easyfyAxios from '@shared/easyfy.axios';

namespace Easyfy.Web.Services.Search {
  export interface ISearchData {
    includeArticles: boolean;
    includeBrands: boolean;
    includePages: boolean;
    searchTerm: string;
    partialView?: string;
  }

  export interface IFocusInParams {
    GetPopularResults: boolean;
    GetCampaignResults: boolean;
  }

  export const Search = async (data: ISearchData, token: string): Promise<any> => {
    return await easyfyAxios.post('/search', data, token);
  };

  export const GetFocusInData = async (data: IFocusInParams, token: string): Promise<any> => {
    return await easyfyAxios.post('/search?handler=focusin', data, token);
  };
}

export default Easyfy.Web.Services.Search;